/**
 * Разворот книги (01-SPEC.md §3.10) и снимок формата картинки.
 */
import { z } from 'zod';
import { SpreadLayoutIdSchema, PageOrientationSchema } from './attributes.js';
import { TextBlockSchema } from './text-block.js';
export const SceneKindSchema = z.enum(['cover', 'spread', 'backCover']);
export const SceneStatusSchema = z.enum(['draft', 'queued', 'generating', 'ready', 'failed']);
/**
 * Снимок формата картинки на момент генерации (01-SPEC.md §3.10 и §3.10.3).
 *
 * `widthPx`/`heightPx` — в обрез (trim), `bleedWidthPx`/`bleedHeightPx` — с вылетами,
 * именно они запрашиваются у модели.
 */
export const ImageSpecSchema = z.object({
    layoutId: SpreadLayoutIdSchema,
    orientation: PageOrientationSchema,
    /** `widthMm / heightMm` в обрез, округлено до трёх знаков. */
    aspect: z.number().positive(),
    widthMm: z.number().positive(),
    heightMm: z.number().positive(),
    widthPx: z.number().int().positive(),
    heightPx: z.number().int().positive(),
    bleedMm: z.number().min(0),
    bleedWidthPx: z.number().int().positive(),
    bleedHeightPx: z.number().int().positive(),
});
export const SceneSchema = z.object({
    id: z.string().min(1),
    bookId: z.string().min(1),
    index: z.number().int().min(0),
    kind: SceneKindSchema.default('spread'),
    /** `null` — берётся раскладка книги (`attributes.layout.default`). */
    layoutId: SpreadLayoutIdSchema.nullable().default(null),
    /** Источник правды по тексту разворота; `textBlocks` — производное (§3.10.6). */
    textRu: z.string().default(''),
    textBlocks: z.array(TextBlockSchema).default([]),
    /** Переопределение `attributes.layout.bandImageRatio` для этого разворота. */
    bandImageRatio: z.number().gt(0).lt(1).nullable().default(null),
    promptEn: z.string().default(''),
    animationPromptEn: z.string().default(''),
    characterIds: z.array(z.string().min(1)).default([]),
    thingIds: z.array(z.string().min(1)).default([]),
    locationId: z.string().min(1).nullable().default(null),
    imageAssetId: z.string().min(1).nullable().default(null),
    videoAssetId: z.string().min(1).nullable().default(null),
    imageSpec: ImageSpecSchema.nullable().default(null),
    imageStale: z.boolean().default(false),
    status: SceneStatusSchema.default('draft'),
    lastError: z.string().nullable().default(null),
});
//# sourceMappingURL=scene.js.map